<section class="match-detail-market sb-card-shell">
  <header class="match-detail-market__header">
    <h2 class="match-detail-market__title">{{ section().title }}</h2>
  </header>

  <div class="match-detail-market__body">
    <div
      class="match-detail-market__grid"
      [class.match-detail-market__grid--two]="section().layout === 'grid2'"
      [class.match-detail-market__grid--three]="section().layout === 'grid3'"
      [class.match-detail-market__grid--list]="section().layout === 'list'"
    >
      @for (option of section().options; track trackOption($index, option)) {
        <button
          type="button"
          class="match-detail-market__option sb-odds-button"
          [class.sb-odds-button--selected]="option.selected"
          [disabled]="!option.available"
          [attr.data-bet-type-id]="option.betTypeId"
          [attr.data-odds-id]="option.oddId"
          [appOddsValueFlash]="option.available ? option.value : null"
          [attr.aria-pressed]="option.selected"
          (click)="onSelectionClick(option)"
        >
          <span class="match-detail-market__option-label">{{ option.displayLabel }}</span>
          <span class="match-detail-market__option-value">{{ option.value | number: '1.1-2' }}</span>
        </button>
      }
    </div>
  </div>
</section>
